import { Grid } from '@mui/material';
import DiscountCodes from '../DiscountCodes/DiscountCodes';
import ProductPrices from '../ProductPrices/ProductPrices';

const Prices = () => (
	<Grid container spacing={3}>
		<Grid size={{ xs: 12 }}>
			<ProductPrices />
		</Grid>
		<Grid size={{ xs: 12 }}>
			<DiscountCodes />
		</Grid>
	</Grid>
);

export default Prices;
